import axios from 'axios';
import FaceDetectionModel from '../../models/FaceDetectionModel';
import apiService from '../apiService';

export default async function saveFaceDetection(detection = FaceDetectionModel()) {
  try {
    let _request = {
      url: `${apiService.getUrl().faceRecognition}faceDetection/createFaceDetection`,
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      data: {
        eventId: detection.eventId,
        system: detection.system,
        guestId: detection.guestId,
        detection: detection.detection,
      }
    }

    if (detection.id) {
      _request = {
        url: `${apiService.getUrl().faceRecognition}faceDetection/updateFaceDetection`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        data: {
          id: detection.id,
          eventId: detection.eventId,
          system: detection.system,
          guestId: detection.guestId,
          detection: detection.detection,
        }
      }
    }

    const _ret = await axios(_request);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return FaceDetectionModel(_ret.data.data);
  } catch (error) {
    console.log('Error saveFaceDetection', error);
    throw error;
  }
}
